export const BITE_ERROR_MESSAGE = 'Request failed with status code 404';
